import Particles from 'react-tsparticles'
import { loadFull } from 'tsparticles'

export const ParticlesAnim = () => {
  const particlesInit = async (main) => {
    await loadFull(main)
  }

  return (
    <div className="absolute inset-0 z-20">
      <Particles
        id="tsparticles"
        init={particlesInit}
        options={{
          fpsLimit: 120,
          interactivity: {
            events: {
              onClick: {
                enable: true,
                mode: 'repulse',
              },
              onHover: {
                enable: true,
                mode: ['bubble', 'attract'],
              },
              resize: true,
            },
            modes: {
              grab: {
                distance: 140,
                lineLinked: {
                  opacity: 1,
                },
              },
              push: {
                quantity: 6,
              },
              trail: {
                particles: 101,
                quantity: 100,
              },
              repulse: {
                distance: 200,
                speed: 1,
                duration: 0.5,
              },
              attract: {
                speed: 0.7,
                distance: 100,
                duration: 10,
              },
              bubble: {
                distance: 150,
                color: '#E4C47F',
                size: 4,
                duration: 2,
                opacity: 8,
                speed: 3,
              },
            },
          },
          particles: {
            color: {
              value: '#AD945F',
              opacity: 1,
            },
            links: {
              color: '#AD945F',
              distance: 150,
              enable: false,
              opacity: 0.5,
              width: 1,
            },
            collisions: {
              enable: false,
            },
            move: {
              direction: 'none',
              enable: true,
              outModes: {
                default: 'bounce',
              },
              random: true,
              speed: 1,
              straight: false,
            },
            number: {
              density: {
                enable: true,
                area: 800,
              },
              value: 300,
            },
            opacity: {
              value: 0.9,
            },
            shape: {
              type: 'circle',
            },
            size: {
              value: { min: 0.5, max: 2 },
            },
          },
          detectRetina: true,
        }}
      />
    </div>
  )
}
